/*
 * 画布列表
 *
 * @Author: xiaoJQ
 * @Date: 2024-05-15 16:25:35
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import positionStyles from 'components/position.less';
import PageItem from 'components/pageItem';
import { ExtractLoading } from 'components/uploadFile';
import { UpPre_svg, DownPre_svg, Unfold_svg, PaintNormal_png, PaintBlue_png, } from 'image/index';
import Icons from 'Icon/Icons.less';
import Styles from './index.less';
var CanvasList = function (props) {
    var _a;
    var _b = useState([]), imgList = _b[0], setImgList = _b[1];
    var _c = useState(50), scaleInput = _c[0], setScaleInput = _c[1];
    var _d = useState([]), activeShapes = _d[0], setActiveShapes = _d[1];
    var _e = useState([]), lastActiveShapes = _e[0], setLastActiveShapes = _e[1];
    var _f = useState({ x: 0, y: 0 }), mouseDownPos = _f[0], setMouseDownPos = _f[1];
    var dispatch = useDispatch();
    var scrollBody = useRef(null);
    useEffect(function () {
        dispatch({ type: 'changeHiddenList', payload: false });
    }, []);
    useEffect(function () {
        setLastActiveShapes(activeShapes);
        setActiveShapes([]);
    }, [props.data.extract.selectId]);
    useEffect(function () {
        var _a, _b;
        if (props.scrollData.extractId) {
            var activeShapeList = props.data.extract.data[props.scrollData.type].filter(function (item) { return item.extractId === props.scrollData.extractId; });
            if (((_a = activeShapeList[0]) === null || _a === void 0 ? void 0 : _a.extractId) !== ((_b = activeShapes[0]) === null || _b === void 0 ? void 0 : _b.extractId)) {
                setLastActiveShapes(activeShapes);
            }
            setActiveShapes(activeShapeList);
        }
    }, [props.scrollData]);
    var scrollMove = function (x, y) {
        var _a;
        (_a = scrollBody.current) === null || _a === void 0 ? void 0 : _a.scrollTo(scrollBody.current.scrollLeft - x, scrollBody.current.scrollTop - y);
    };
    useEffect(function () {
        if (props.data.extract.status === 'success') {
            upDownPre(0.5);
            setImgList(props.data.extract.data.tieImages);
        }
    }, [props.data.extract.status]);
    useEffect(function () {
        upDownPre(0.5);
    }, [props.control.hiddenList]);
    var handleScroll = function (left, top) {
        scrollBody.current.scrollTo(left - scrollBody.current.offsetWidth / 2, top - scrollBody.current.offsetWidth / 2);
    };
    var backHomePage = function () {
        dispatch({ type: 'backHomePage', payload: 'backHomePage' });
    };
    var changePreValue = function (e) {
        setScaleInput(e.target.value);
    };
    var preKeyDown = function (e) {
        if (e.keyCode !== 13) {
            return;
        }
        upDownPre(parseFloat(e.target.value) / 100);
    };
    var upDownPre = function (value) {
        var scaleScal = value;
        if (scaleScal <= 0.1) {
            scaleScal = 0.1;
        }
        if (scaleScal >= 1.5) {
            scaleScal = 1.5;
        }
        dispatch({ type: 'changeScale', payload: scaleScal });
        setScaleInput(Math.floor(scaleScal * 100));
    };
    return (React.createElement("div", { className: Styles.displayArea },
        React.createElement("div", { className: classNames(Styles.displayNav, positionStyles['between_center']) },
            React.createElement("div", { className: positionStyles['inTheMiddle'] },
                React.createElement("div", { style: {
                        display: props.global.viewType === 'ie_show_task' ? 'none' : 'flex',
                    }, onClick: backHomePage, className: classNames(Styles.backHomePage, Icons['icon-back']) }),
                React.createElement("div", { className: classNames(positionStyles['inTheMiddle'], Styles.zoomArea) },
                    React.createElement("img", { alt: '', src: DownPre_svg, className: Styles.upDownBtn, onClick: function () { return upDownPre(props.control.scale - 0.1); } }),
                    React.createElement("input", { className: Styles.pre, onChange: function (e) { return changePreValue(e); }, onKeyDown: function (e) { return preKeyDown(e); }, value: scaleInput }),
                    React.createElement("img", { alt: '', src: UpPre_svg, className: Styles.upDownBtn, onClick: function () {
                            upDownPre(props.control.scale + 0.1);
                        } }))),
            React.createElement("div", { className: Styles.operateRightNav },
                React.createElement("div", { style: {
                        backgroundColor: props.control.paint ? '#f2f6ff' : null,
                        color: props.control.paint ? '#5582F3' : null,
                        cursor: 'pointer',
                    }, className: Styles.startPaint, onClick: function () {
                        return dispatch({
                            type: 'changeStartPaint',
                            payload: !props.control.paint,
                        });
                    } },
                    React.createElement("img", { src: props.control.paint ? PaintBlue_png : PaintNormal_png }),
                    React.createElement("div", { style: {
                            marginLeft: '5px',
                        } }, "\u6846\u9009")),
                React.createElement("div", { style: {
                        display: props.control.hiddenList ? 'flex' : 'none',
                    }, className: Styles.showListBox },
                    React.createElement("img", { onClick: function () {
                            return dispatch({ type: 'changeHiddenList', payload: false });
                        }, alt: '', style: {
                            width: '18px',
                            cursor: 'pointer',
                            display: props.data.extract.status === 'loading' ? 'none' : 'flex',
                        }, src: Unfold_svg })))),
        React.createElement("div", { className: Styles.displayBody },
            React.createElement("div", { className: classNames(Styles.header, positionStyles['start_center']) },
                React.createElement("span", null, props.file.displayPage.name)),
            React.createElement("div", { ref: scrollBody, id: 'scrollBody', onMouseDown: function (e) {
                    if (!props.control.paint) {
                        setMouseDownPos({ x: e.clientX, y: e.clientY });
                    }
                }, onMouseMove: function (e) {
                    if (!props.control.paint && e.buttons === 1) {
                        setMouseDownPos({ x: e.clientX, y: e.clientY });
                        scrollMove(e.clientX - mouseDownPos.x, e.clientY - mouseDownPos.y);
                    }
                }, onMouseUp: function (e) {
                    if (!props.control.paint) {
                        setMouseDownPos({ x: 0, y: 0 });
                    }
                }, style: { cursor: props.control.paint ? null : 'grab' }, className: classNames(Styles.body, (_a = {},
                    _a[positionStyles.inTheMiddle] = props.data.extract.status === 'loading' ||
                        props.data.extract.status === 'error',
                    _a)) }, props.data.extract.status === 'loading' ||
                props.data.extract.status === 'error' ? (React.createElement(ExtractLoading, { fileInfo: props.file.displayPage, status: props.data.extract.status })) : (imgList === null || imgList === void 0 ? void 0 : imgList.map(function (item, index) {
                return (React.createElement(PageItem, { handleScroll: handleScroll, selectId: props.data.extract.selectId, extractSeq: props.data.extract.data.extractSeq, llmSeq: props.data.extract.data.llmSeq, environment: props.global.environment, drawJson: props.data.extract.data.drawJson, wordSelection: props.data.extract.wordSelection, responseData: props.data.responseData, paint: props.control.paint, calcuJson: props.data.extract.data.calcuJson.filter(function (json) { return json.pageNum === item.pageNum; }), activeShapes: activeShapes, lastActiveShapes: lastActiveShapes, scale: props.control.scale, hiddenList: props.control.hiddenList, imgData: item, listJson: props.data.extract.data.listJson, tableJson: props.data.extract.data.tableJson, llmTableJson: props.data.extract.data.llmTableJson, tableListJson: props.data.extract.data.tableListJson, llmTableListJson: props.data.extract.data.llmTableListJson, key: index }));
            }))))));
};
export default connect(function (state) { return state; })(CanvasList);
